import * as React from 'react';
export const BRSvg = React.forwardRef(function BRSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#24B47E',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        fillRule: 'nonzero',
        d: 'M7.999 1 15 6l-7.001 5L1 5.92z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        fillRule: 'nonzero',
        d: 'M8 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'M10.848 6.945a2.99 2.99 0 0 1-.561.997c-1.28-1.4-3.17-2.297-5.238-2.485a2.99 2.99 0 0 1 .384-1.01c2.076.247 4.024 1.158 5.415 2.498Z',
      }),
    ),
  );
});
BRSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var BR = {
  category: 'flag',
  colorable: false,
  name: 'BR',
  svg: BRSvg,
};
